app.service('lastViewed', function(cookie, front, _, pageConfig) {
	let $self;
	let $clearButton;
	let offsetTop;

	let state = {
		isLoading: false,
		isLoaded: false,
		isViewed: false
	};

	function logEvent(params) {
		const plu = pageConfig.getData('productCard').plu || '';
		const currentUrl = window.location.href;
		const currentPage = front.page();

		const defaults = {
			f03: plu,
			f06: currentUrl,
			f07: currentPage
		};

		const event = $.extend(defaults, params);

		app.logEvent(event);
	}

	function logProductClick() {
		const index = parseInt($(this).index());
		const productPlu = $(this).data('plu');

		logEvent({
			id: 'Oo_klik',
			f04: productPlu,
			f05: index
		});
	}

	function logCarouselView() {
		const productsPlu = $self
			.find('li')
			.map((i, el) => el.dataset.plu)
			.get()
			.join(';');

		logEvent({
			id: 'Oo_view',
			f04: 1,
			f05: productsPlu
		});

		$clearButton.on('click', function() {
			removeAllProducts();
		});
	}

	function handleScroll(scrollY, windowHeight) {
		if (!state.isViewed && state.isLoaded) {
			if (windowHeight + scrollY > offsetTop) {
				state.isViewed = true;
				logCarouselView();
			}
		}

		if (state.isLoading) {
			return;
		}

		if (!state.isLoaded && scrollY > 600) {
			loadCarousel();
		}
	}

	function getLastViewedProducts() {
		const currentId = pageConfig.getData('productCard').id;

		return cookie.isEmpty('lastViewedProducts')
			? []
			: cookie
					.get('lastViewedProducts')
					.split('a')
					.filter(productId => String(productId) !== String(currentId));
	}

	function loadProducts(products) {
		return products.map(productId =>
			$.ajax({
				url: '/last-viewed-single-product.ltr',
				data: {
					productId
				},
				success:function(html){
					if(!$(html).find('.product-prices').length) {
						removeProduct(productId);
					}
				}
			})
		);
	}

	function loadCarousel() {
		state.isLoading = true;

		const lastViewedProducts = getLastViewedProducts();

		const requests = loadProducts(lastViewedProducts);

		$.when(...requests).then((...products) => {
			if (products.length) {
				let html='';
				if(typeof(products[0]) ==='string'){
					if($(products[0]).find('.product-prices').length){
						html=products[0];
					}
				}else{
					html=products.filter(getActiveProducts).map(p => p[0]).join('');
				}
				$self
					.addClass('showed loading')
					.removeClass('loading')
					.find('ul')
					.append(html);

				offsetTop = $self.offset().top;
			}

			state.isLoading = false;
			state.isLoaded = true;
		});
	}

	function getActiveProducts(product) {
		const $product = $(product[0]);
		if($product.find('.product-prices').length) {
			return product;
		}
	}

	function setEvents() {
		$self.on('click', '.js-UA-product', logProductClick);

		$clearButton.on('click', function() {
			removeAllProducts();
		});

		const windowHeight = $(window).height();

		_.onScroll(scrollY => handleScroll(scrollY, windowHeight));
	}
	function removeProduct(id) {
		$.ajax({
			url: '/last-viewed-products-updater.ltr',
			method:'POST',
			data:{
				ids: id,
				action: 'remove'
			}
		});
	}
	function removeAllProducts() {
		$.ajax({
			url: '/last-viewed-products-updater.ltr',
			type: 'POST',
			data: {
				action: 'removeAll'
			}, success: function complete() {
				$self.removeClass('showed');
			}
		});
	}

	function init() {
		$self = $('#last-viewed');
		$clearButton = $('.js-clear', $self);


		setEvents();

		if (front.page() === 'main-page') {
			loadCarousel();
		}
	}

	return {
		init: init,
		getProducts: getLastViewedProducts,
		clear: removeAllProducts
	};
});
